import { memo } from 'react';

import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';

const StyledModal = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.primary.blackTransparency,
  zIndex: 1200,
  width: '100vw',
  height: '100vh',
  position: 'fixed',
  top: 0,
  left: 0,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  overflowY: 'scroll',
}));

const getModalSizeStyles = (modalWidth) => {
  const sizes = {
    loading: {
      width: '200px',
      height: '200px',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',

    },
    auto: {
      width: '80%',
      maxWidth: '1000px',
      minWidth: '600px',
    },
    '1250px': {
      width: '80%',
      maxWidth: '1250px',
      minWidth: '750px',
    },
    '850px': {
      width: '80%',
      maxWidth: '850px',
      minWidth: '500px',
    },
    '750px': {
      width: '80%',
      maxWidth: '750px',
      minWidth: '450px',
    },
    '600px': {
      width: '80%',
      maxWidth: '600px',
      minWidth: '400px',
    },
    '550px': {
      width: '80%',
      maxWidth: '550px',
      minWidth: '350px',
    },
    '500px': {
      width: '80%',
      maxWidth: '500px',
      minWidth: '350px',
    },
    '90p': {
      width: '90%',
      maxWidth: '1024px',
      minWidth: '350px',
    },
  };

  return sizes[modalWidth] || sizes.auto;
};

const StyledModalContent = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'modalWidth',
})(({ theme, modalWidth }) => ({
  backgroundColor: theme.palette.primary.white,
  margin: 'auto',
  padding: '20px',
  borderRadius: theme.shape.customBorderRadius[6],
  boxShadow: `4px 4px 8px ${theme.palette.primary.blackTransparency}`,
  position: 'relative',
  overflow: 'visible',
  ...getModalSizeStyles(modalWidth),

  [theme.breakpoints.down('sm')]: {
    width: '60% !important',
    maxWidth: '250px',
    minWidth: '150px',
  },
}));

const ModalContainer = ({
  display,
  modalWidth = 'auto',
  children,
}) => {

  if (!display) return null;

  return (
    <StyledModal>
      <StyledModalContent modalWidth={modalWidth}>
        {children}
      </StyledModalContent>
    </StyledModal>
  );
};

export default memo(ModalContainer);